export default __webpack_public_path__ + "static/01-e4cab6b0ad3569dc42621ac0b4f4884f.png";